import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import VueCookie from 'vue-cookie'
import imagePreloader from 'vue-image-preloader'
import VueZoomer from 'vue-zoomer'

import VueMoment from 'vue-moment'
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from "vue-loaders"

import GameData from "./plugins/GameData";
import GameManager from "./plugins/GameManager";

import Image from "@/components/modules/Image";
import PinchZoom from "vue-pinch-zoom";

// import './registerServiceWorker'


import './assets/css/fonts.css'

global.jQuery = require('jquery');
const $ = global.jQuery;
window.jQuery = $;
window.$ = $;

window._ = require('lodash');
window.moment = require('moment')


Vue.use(VueCookie)
Vue.use(imagePreloader)
Vue.use(VueMoment)
Vue.use(VueLoaders)

Vue.use(VueZoomer)

Vue.use(GameData)
Vue.mixin(GameManager)

Vue.component('v-image', Image)
Vue.component("pinch-zoom", PinchZoom);


Vue.config.productionTip = false
// Vue.config.errorHandler = (err, vm, info) => {
// 	console.info('vue error :', err, vm, info)
// }
window.onerror = (msg, url, line, col, error) => {
	console.info('global error :', msg, url, line, col, error)
}

window.vm = new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
